import React, { useState, useEffect } from "react";
import "./../../assets/styles/custom/components/HoverProfile.scss";
import { Link } from "react-router-dom";
import firebase from "../../Firebase/firebase";
import { useQuery } from "@apollo/client";
import { HoverProfileQuery } from "./Queries/HoverProfileQuery";
import { Dashboards } from "../Dashboard/Crew/CrewDashboard/Queries/DashboardQuery";
import Loading from "./../../assets/images/loading.gif";
import Loading2 from "./../../assets/images/loading2.gif";
import { useHistory } from "react-router-dom";
const HoverProfile = (props) => {
  let history = useHistory();
  const [users, setusers] = useState({});
  //new start
  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token,
        });
      } else console.log("SIGNED OUT");
    });
  }, []);
  const logout = () => {
    firebase.auth().signOut();
    history.push("/");
  };
  const { data } = useQuery(HoverProfileQuery, {
    variables: { id: users?.token?.claims?.user_id },
  });

  const { data: data2 } = useQuery(Dashboards, {
    variables: { id: users?.token?.claims?.user_id },
  });
  // const {data} = useQuery(HoverProfiles)

  return (
    <div
      className="hover-profile-container animate__animated animate__fadeIn"
      style={{ display: props.hoverProfile ? "block" : "none" }}
      onMouseLeave={props.onMouseLeave}
    >
      <div className="top-part">
        <div className="user-name">
          {users?.token?.claims?.user_id &&
          data?.aatmsv4_register?.length === 1 &&
          data ? (
            data?.aatmsv4_register[0]?.name
          ) : (
            <img width="100px" src={Loading2} alt="" />
          )}
        </div>
        <div className="profile-image">
          <img
            src={
              users?.token?.claims?.user_id &&
              data?.aatmsv4_register?.length === 1 &&
              data
                ? data?.aatmsv4_register[0]?.photo
                : Loading
            }
            alt="Profile"
            height="100%"
            width="100%"
          />
        </div>
        <div className="right-part">
          <div className="dashboard-type">
            {users?.token?.claims?.user_id &&
            data?.aatmsv4_register?.length === 1 &&
            data ? (
              data?.aatmsv4_register[0]?.emailofficial
            ) : (
              <img width="100px" src={Loading2} alt="" />
            )}
          </div>
          <div className="user-email">
            {users?.token?.claims?.user_id &&
            data?.aatmsv4_register?.length === 1 &&
            data ? (
              data?.aatmsv4_register[0]?.email
            ) : (
              <img width="100px" src={Loading2} alt="" />
            )}
          </div>
          {/* <Link to="/main-dashboard" className="back-to-login-button">
            Back to Login Menu
          </Link> */}
        </div>
      </div>
      <div className="bottom-part">
        <div className="profile-items">
          <div className="profile-items--title">ECODE</div>
          <div className="text">
            {users?.token?.claims?.user_id &&
            data?.aatmsv4_register?.length === 1 &&
            data ? (
              data?.aatmsv4_register[0]?.ecode
            ) : (
              <img width="100px" src={Loading2} alt="" />
            )}
          </div>
        </div>
        <div className="profile-items">
          <div className="profile-items--title">Fleet</div>
          <div className="text">
            {users?.token?.claims?.user_id ? (
              data2?.aatmsv4_crews[0]?.fleet?.aircraft
            ) : (
              <img width="100px" src={Loading2} alt="" />
            )}
          </div>
        </div>
        <div className="profile-items">
          <div className="profile-items--title">Rank</div>
          <div className="text">
            {users?.token?.claims?.user_id &&
            data?.aatmsv4_register?.length === 1 &&
            data ? (
              data?.aatmsv4_register[0]?.client?.ranks[0].rank
            ) : (
              <img width="100px" src={Loading2} alt="" />
            )}
          </div>
        </div>
        <div className="profile-items">
          <div className="profile-items--title">Phone 1</div>
          <div className="text">
            {users?.token?.claims?.user_id &&
            data?.aatmsv4_register?.length === 1 &&
            data ? (
              data?.aatmsv4_register[0]?.phone1
            ) : (
              <img width="100px" src={Loading2} alt="" />
            )}
          </div>
        </div>
        <Link to="/main-dashboard" className="back-to-login-button">
          Back to Login Menu
        </Link>
        <div className="logout-container" onClick={logout}>
          <div className="fa fa-power-off"> Logout</div>
        </div>
      </div>
    </div>
  );
};
export default HoverProfile;
